import React from 'react';
import ReactDOM from 'react-dom';
import { routerMiddleware } from 'react-router-redux';
import { createStore } from 'redux/store';

import createGoogleTagManager from '@ott/google-tag-manager';

import '@ott/styles/css-vars-default.scss';

import { setSSR } from 'src/redux/modules/common/ssr/actions';

import 'src/styles/base-settings.css';

import Root from './Root';
import history from './helpers/history';

import 'intersection-observer';
import './styles/solar-overwrites.scss';

const store = createStore([routerMiddleware(history)], window.preloadedState);

const container = document.getElementById('root');

createGoogleTagManager('GTM-K5DP3HL');

if (__DEV__ || __WHITE_LABEL__) {
  ReactDOM.render(<Root store={store} history={history} />, container, () => {
    store.dispatch(setSSR(false));
  });
} else {
  ReactDOM.hydrate(<Root store={store} history={history} />, container, () => {
    store.dispatch(setSSR(false));
  });
}
